const once = ( el, ok, fail ) =>
	new Promise( ( resolve ) => {
		const done = () => {
			el.removeEventListener( ok, done );
			el.removeEventListener( fail, done );
			resolve();
		};
		el.addEventListener( ok, done );
		el.addEventListener( fail, done );
	} );

const waitImage = ( el ) => {
	if ( el.complete && el.naturalWidth ) return Promise.resolve();
	if ( typeof el.decode === 'function' ) {
		return el.decode().catch( () => {} );
	}
	return once( el, 'load', 'error' );
};

const waitVideo = ( el ) => {
	if ( el.readyState >= 2 ) return Promise.resolve();
	return once( el, 'loadeddata', 'error' );
};

export const waitForAsset = ( item ) => {
	const el = item?.el;
	if ( el ) {
		const tag = el.tagName;
		if ( tag === 'IMG' ) return waitImage( el );
		if ( tag === 'VIDEO' ) return waitVideo( el );
		return Promise.resolve();
	}
	const src = typeof item === 'string' ? item : item?.src;
	if ( ! src ) return Promise.resolve();
	return fetch( src ).then(
		() => {},
		() => {}
	);
};

export class LoadQueue {
	constructor() {
		this.numItems = 0;
		this._done = 0;
		this._progress = [];
		this._complete = [];
		this._finished = false;
	}

	loadFile( item ) {
		this.numItems += 1;
		waitForAsset( item ).finally( () => this._tick() );
	}

	on( name, fn ) {
		if ( name === 'progress' ) {
			this._progress.push( fn );
			if ( this.numItems ) {
				fn( { progress: this._done / this.numItems } );
			}
		} else if ( name === 'complete' ) {
			this._complete.push( fn );
			if ( this._finished || this.numItems === 0 ) fn();
		}
		return this;
	}

	_tick() {
		this._done += 1;
		this._progress.forEach( ( fn ) =>
			fn( { progress: this._done / this.numItems } )
		);
		if ( this._done >= this.numItems ) {
			this._finished = true;
			this._complete.forEach( ( fn ) => fn() );
		}
	}
}
